import { useT } from '@transifex/react'
import { useCallback } from 'react'

export const useI18NToastMessage = () => {
  const t = useT()
  return useCallback(
    (key?: string, vars: Record<string, any> = {}) => {
      if (!key) {
        return ''
      }

      // Arrange the cases in alphabetical order
      switch (key) {
        case 'block.lspayEcom.exchange': {
          return t(
            'Unable to exchange items for eCom sales paid with Lightspeed Payments.',
            { _context: 'Toast Notification' }
          )
        }
        case 'customer.update.success': {
          const { customerName } = vars
          return t('This customer “{customerName}” has been updated.', {
            _context: 'Toast Notification',
            customerName,
          })
        }
        case 'customer.create.success': {
          const { customerName } = vars
          return t('This customer “{customerName}” has been created.', {
            _context: 'Toast Notification',
            customerName,
          })
        }
        case 'park.sale.success': {
          return t('Your sale was successfully parked.', {
            _context: 'Toast Notification',
          })
        }
        case 'product.add.fail': {
          return t(
            "We're unable to add product created to the sale. Try again.",
            {
              _context: 'Toast Notification',
            }
          )
        }
        case 'product.add.fail.name': {
          const { productName } = vars
          return t(
            "We're unable to add “{productName}” created to the sale. Try again.",
            {
              _context: 'Toast Notification',
              productName,
            }
          )
        }
        case 'product.add.success': {
          const { productName } = vars
          return t('“{productName}” added', {
            _context: 'Toast Notification',
            productName,
          })
        }
        case 'record.cash.movement.negative': {
          return t(
            'There was a problem recording this cash movement, please try again.',
            { _context: 'Toast Notification' }
          )
        }
        case 'variants.add.success': {
          const { productName } = vars
          return t('Variants added to “{productName}”', {
            _context: 'Toast Notification',
            productName,
          })
        }
        case 'customer.view.modal.negative': {
          return t(
            'There was a problem loading the details for that customer. Please try again.',
            { _context: 'Toast Notification' }
          )
        }

        case 'issue.store.credit.negative': {
          return t('There was an error issuing the store credit.', {
            _context: 'Toast Notification',
          })
        }
        case 'mark-as-unfulfilled.delivery.success': {
          const { totalQuantity } = vars
          return t(
            '{totalQuantity, plural, one {{totalQuantity} item is marked for delivery} other {All {totalQuantity} items are marked for delivery}}',
            {
              _context: 'Mark as unfulfilled modal - success notification',
              totalQuantity,
            }
          )
        }
        case 'mark-as-unfulfilled.negative': {
          return t('Failed to mark as unfulfilled, please try again.', {
            _context: 'Mark as unfulfilled modal - error notification',
          })
        }
        case 'mark-as-unfulfilled.pickup.success': {
          const { totalQuantity } = vars
          return t(
            '{totalQuantity, plural, one {{totalQuantity} item is marked for pickup} other {All {totalQuantity} items are marked for pickup}}',
            {
              _context: 'Mark as unfulfilled modal - success notification',
              totalQuantity,
            }
          )
        }
      }

      return ''
    },
    [t]
  )
}
